
import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import PublicFooter from "../Footer/PublicFooter";

export default function PublicLayout() {
  return (
    <Flex
      direction="column"
      minH="100vh"
      w="100%"
      bg="#f7fbfc"
    >
      <Box as="main" flex="1" w="100%">
        <Outlet />
      </Box>

      <PublicFooter />
    </Flex>
  );
}
